// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DashboardOutlinedSvg from "@ant-design/icons-svg/es/asn/DashboardOutlined";
import AntdIcon from '../components/AntdIcon';

var DashboardOutlined = function DashboardOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: DashboardOutlinedSvg
  }));
};

DashboardOutlined.displayName = 'DashboardOutlined';
export default React.forwardRef(DashboardOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/DashboardOutlined.js
// module id = 907
// module chunks = 0